"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderTotalsState = /** @class */ (function () {
    function OrderTotalsState() {
        this.showOrderTotal = false;
        this.showDueTodayModal = false;
        this.showDueTodaySeeDetailsLink = false;
        this.showDueFirstBillSeeDetailsLink = false;
    }
    return OrderTotalsState;
}());
exports.default = OrderTotalsState;
//# sourceMappingURL=OrderTotalsState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/OrderTotals/OrderTotalsState.js
// module id = 2344
// module chunks = 8